import { Outlet } from "react-router-dom";

const DevLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default DevLayout;
